import { clearAuth } from "../auth";

const getDefaultMessage = (method) => {
  return method === "GET"
    ? "Failed to load data, please try again."
    : "There was some error while saving, please try again.";
};

export class ApiError extends Error {
  constructor(message, response, data) {
    super(message);
    this.name = "ApiError";
    this.status = response?.status;
    this.data = data;
    this.messages = data?.messages ?? [];
    this.errors = data?.errors ?? {};
  }
}

export const getApiMessage = (data, fallback) => {
  if (data?.message) return data.message;
  if (Array.isArray(data?.messages) && data.messages.length > 0) return data.messages[0];

  return fallback;
};

export const apiRequest = async (endpoint, options = {}) => {
  const url = endpoint.startsWith("http")
    ? endpoint
    : process.env.REACT_APP_BASE_API_URL + endpoint;
  const method = options.method ?? "GET";
  const token = localStorage.getItem("token");
  const headers = {
    "Accept": "application/json",
    ...(options.headers ?? {}),
  };

  if (token) {
    headers.Authorization = "Bearer " + token;
  }

  const response = await fetch(url, {
    ...options,
    method,
    headers,
  });
  const data = await response.json().catch(() => null);

  if (response.status === 401) {
    clearAuth();
  }

  if (!response.ok || data?.status === "error" || data?.status === "validation_error") {
    throw new ApiError(
      getApiMessage(data, getDefaultMessage(method)),
      response,
      data
    );
  }

  return data;
};
